import React, { Fragment, useLayoutEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  TextField,
  CdsamCityAndStateSelect
} from "components"
import CdsamMap from "./CdsamMap"
import { formatMobilePhone } from "utils"
import CdsamFormFooter from "./CdsamFormFooter"
import classes from "./index.module.scss"

const initialFormErrorsState = {
  address: "",
  city: "",
  state: "",
  zipCode: "",
  coordinates: "",
  recipientName: "",
  recipientPhoneNumber: "",
}

const CdsamForm = (props) => {
  const {
    isGuestOrder,
    addressForEdit,
    setAddressForEdit,
    setUserAddresses,
    setSelectedAddress,
    setModalContent,
    selectedUserAccount,
    setOpenMapAddressModal
  } = props

  const [t] = useTranslation()

  const selectedCashierBranch =
    useSelector(state =>
      state.userAccountInfo.selectedCashierBranch
    )

  const initialFormState = {
    address: "",
    city: "",
    state: "",
    recipientName: "",
    recipientPhoneNumber: "",
    coordinates: selectedCashierBranch.location.coordinates
  }

  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)

  const handleChange = (text, name) => {
    setForm(prev => ({ ...prev, [name]: text }))
  }

  const fillForm = () => {
    if (addressForEdit === null) return

    setForm({
      zipCode: addressForEdit.zipCode,
      address: addressForEdit.address,
      city: addressForEdit.city,
      state: addressForEdit.state,
      coordinates: addressForEdit.location.coordinates,
      recipientName: addressForEdit.recipientName,
      recipientPhoneNumber:
        formatMobilePhone(addressForEdit.recipientPhoneNumber)
    })
  }

  useLayoutEffect(() => {
    fillForm()
  }, [])

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {!!addressForEdit ? t("ویرایش_آدرس") : t("افزودن_آدرس")}
        </div>
        
        {
          !selectedCashierBranch.customerAddressRules.onlyFromBranchStateAndCity &&
          <CdsamCityAndStateSelect
            form={form}
            setForm={setForm}
            formErrors={formErrors}
          />
        }

        <TextField
          type="text"
          label={t("آدرس")}
          className={classes["input"]}
          value={form.address}
          onChange={(e) => handleChange(e.target.value, "address")}
          error={formErrors.address}
        />

        <TextField
          type="text"
          label={t("کدپستی")}
          className={classes["input"]}
          value={form.zipCode}
          onChange={(e) => handleChange(e.target.value, "zipCode")}
          error={formErrors.zipCode}
        />

        <TextField
          label={t("نام_گیرنده")}
          value={form.recipientName}
          error={formErrors.recipientName}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "recipientName")}
        />

        <TextField
          label={t("شماره_موبایل_گیرنده")}
          value={form.recipientPhoneNumber}
          error={formErrors.recipientPhoneNumber}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "recipientPhoneNumber")}
        />

        <CdsamMap
          form={form}
          setForm={setForm}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          addressForEdit={addressForEdit}
        />
      </div>

      <CdsamFormFooter
        form={form}
        setForm={setForm}
        setUserAddresses={setUserAddresses}
        setModalContent={setModalContent}
        setFormErrors={setFormErrors}
        addressForEdit={addressForEdit}
        setAddressForEdit={setAddressForEdit}
        setSelectedAddress={setSelectedAddress}
        initialFormErrorsState={initialFormErrorsState}
        selectedUserAccount={selectedUserAccount}
        isGuestOrder={isGuestOrder}
        setOpenMapAddressModal={setOpenMapAddressModal}
      />
    </Fragment>
  )
}

export default CdsamForm